// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * ARCHAT — API de mensajes no leídos (badge)
 */

import { request } from '../services/apiClient';
import { API_BASE, STORAGE_KEYS } from '../utils/constants';

function buildUrl() {
  const base = (API_BASE && API_BASE.startsWith('http'))
    ? API_BASE.replace(/\/$/, '')
    : (typeof window !== 'undefined'
        ? (window.location.origin + (API_BASE.startsWith('/') ? API_BASE : '/' + API_BASE))
        : API_BASE
      ).replace(/\/$/, '');
  return base + '/messages/unread_count.php';
}

/**
 * Obtiene el número de mensajes no leídos del usuario actual.
 * @returns {Promise<number>}
 */
export async function getUnreadCount() {
  try {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    const userId = localStorage.getItem(STORAGE_KEYS.USER_ID);
    if (!token || !userId) return 0;
    const res = await request(buildUrl());
    const data = await res.json().catch(() => ({}));
    return typeof data.unread === 'number' ? data.unread : 0;
  } catch (e) {
    console.warn('ignored unread_count error', e?.message || e);
    return 0;
  }
}
